enum UPLOAD_PHOTO_STATES {
  take = 'TAKE',
  confirmTaking = 'CONFIRM_TAKING',
  upload = 'UPLOAD',
  scan = 'SCAN',
}

export {UPLOAD_PHOTO_STATES};
